import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson10/Answer/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson10/Answer/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson10/Answer/Issue3";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson10AnswerProps = {
  materialCode: string;
  lessonNo: number;
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson10Answer = (props: Lesson10AnswerProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(1)}
        />
      </div>
      <div className={styles.section}>
        <Issue2
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(2)}
        />
      </div>
      <div className={styles.section}>
        <Issue3
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(3)}
        />
      </div>
    </>
  );
};
export default Lesson10Answer;
